<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Чат с&nbsp;клиентом</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="kak-otvetit-ili-napisat"
            class="typography__headline2"
          >
            Как ответить или написать
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              В&nbsp;меню слева перейдите в&nbsp;раздел &laquo;Чаты&raquo;. Если есть чаты, ожидающие ответа,
              на&nbsp;разделе будет отметка с&nbsp;их&nbsp;количеством.
            </p>

            <p>
              Сверху списка есть поиск по&nbsp;всем чатам с&nbsp;клиентами и&nbsp;возможность перейти
              к&nbsp;архивированным.
            </p>

            <p>В&nbsp;самом списке будут все активные чаты.</p>

            <p>
              В&nbsp;группе &laquo;Ждут ответа&raquo; находятся диалоги с&nbsp;сообщениями от&nbsp;клиентов, ожидающие
              ответа.
            </p>

            <p>Нажмите на&nbsp;нужный чат.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/chat-s-klientom-1.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>В&nbsp;чате можно посмотреть всю хронологию общения с&nbsp;клиентом.</p>

            <p>После ответа, чат уйдет в&nbsp;группу &laquo;Отвечено&raquo;.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/chat-s-klientom-2.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              Также клиенту можно отправить изображение или файл. Для этого нажмите на&nbsp;иконку скрепки в&nbsp;поле
              ввода сообщения.
            </p>

            <p>После выбора нужного, нажмите &laquo;Отправить&raquo; в&nbsp;появившемся окне предпросмотра.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/chat-s-klientom-3.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <FaqArticlesImageModalButton
            image-source="/images/faq/chat-s-klientom-4.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="ypravlenie-chatom"
            class="typography__headline2"
          >
            Управление чатом
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              В&nbsp;чате с&nbsp;клиентом справа есть его основная информация и&nbsp;возможность быстро открыть страницу
              профиля.
            </p>

            <p>Ниже находятся кнопки для управления чатом.</p>

            <p>
              &laquo;Убрать в&nbsp;архив&raquo; позволяет для удобства убрать выбранный чат в&nbsp;архив, если текущий
              диалог завершен. Чат автоматически вернется в&nbsp;активные, если клиент или вы&nbsp;напишете в&nbsp;него.
            </p>

            <p>
              &laquo;Тихий режим&raquo; убирает уведомления от&nbsp;выбранного чата и&nbsp;не&nbsp;позволяет ему
              выходить из&nbsp;архива при получении новых сообщений.
            </p>

            <p>
              &laquo;В&nbsp;чёрный список&raquo; аналогично такой-же настройке на&nbsp;странице клиента&nbsp;&mdash;
              игнорирование любых сообщений или новых заказов и&nbsp;записей от&nbsp;этого клиента.
            </p>

            <p>По&nbsp;кнопкам добавления происходит быстрый переход к&nbsp;странице добавления нужной сущности.</p>

            <p>
              По&nbsp;кнопке &laquo;Удалить чат&raquo; вся переписка и&nbsp;файлы будут стерты без возможности возврата.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/chat-s-klientom-5.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="chati-v-arhive"
            class="typography__headline2"
          >
            Чаты в архиве
          </FaqArticlesBlockHeading>

          <p>Нажмите &laquo;Убрать в&nbsp;архив&raquo; в&nbsp;нужном чате.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/chat-s-klientom-6.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            Чат будет перемещен в&nbsp;архив и&nbsp;исчезнет из&nbsp;списка активных. Перейдите в&nbsp;раздел
            с&nbsp;архивом.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/chat-s-klientom-7.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              Если снова справа нажать на&nbsp;кнопку с&nbsp;архивом&nbsp;&mdash; чат вернется в&nbsp;список активных.
            </p>

            <p>Также чат автоматически вернется в&nbsp;активные, если клиент или вы&nbsp;напишете в&nbsp;него.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/chat-s-klientom-8.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Клиенты",
    url: "/faq/categories/klienty",
  },
  {
    name: "Чат с&nbsp;клиентом",
  },
];

const relatedArticles = [
  {
    name: "Добавление и&nbsp;редактирование клиента",
    slug: "dobavleniye-i-redaktirovaniye-klienta",
  },
  {
    name: "Список клиентов и&nbsp;их данные",
    slug: "spisok-klientov-i-ikh-dannye",
  },
];

const menu = [
  {
    name: "Как&nbsp;ответить&nbsp;или&nbsp;написать",
    url: "kak-otvetit-ili-napisat",
  },
  {
    name: "Управление чатом",
    url: "ypravlenie-chatom",
  },
  {
    name: "Чаты в архиве",
    url: "chati-v-arhive",
  },
];

useSeoMeta({
  title: "Чат с клиентом",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
</style>
